export const SET_ALL_FRAME_WORK_LIST =
  "SET_ALL_FRAME_WORK_LIST";